import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';

const CardTypes = {
    NONE: '',
    AMEX: 'AX',
    DINERS: 'DC',
    DISCOVER: 'DI',
    JCB: 'JC',
    MASTER_CARD: 'MC',
    VISA: 'VI',
    VISA_COBRAND: 'VIC',
};
const CardTypeImageUrls = [
    { cardType: CardTypes.VISA, imageUrlNo: '3' },
    { cardType: CardTypes.AMEX, imageUrlNo: '1' },
    { cardType: CardTypes.DINERS, imageUrlNo: '6' },
    { cardType: CardTypes.DISCOVER, imageUrlNo: '4' },
    { cardType: CardTypes.JCB, imageUrlNo: '7' },
    { cardType: CardTypes.MASTER_CARD, imageUrlNo: '2' },
    { cardType: CardTypes.VISA_COBRAND, imageUrlNo: '8' },
];
const CardPattern = {
    SECURITY_CODE: /^[0-9]{3}$/,
    SECURITY_CODE_AMEX: /^[0-9]{4}$/,
    AMEX: /^3[47][0-9]{13}$/,
    DINERS: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    DISCOVER: /^6(?:011\d{12}|5\d{14}|4[4-9]\d{13}|22(?:1(?:2[6-9]|[3-9]\d)|[2-8]\d{2}|9(?:[01]\d|2[0-5]))\d{10})$/,
    JCB: /^(?:2131|1800|35\d{3})\d{11}$/,
    MASTER: /^(2[2-7]|5[1-5])[0-9]{14}$/,
    VISA: /^4[0-9]{12}(?:[0-9]{3})?$/,
    REPEATING_CHARACTERS: /^(.)\1*$/,
    VISA_COBRAND: /^4418379[4-5][0-9]{8}$/,
};

class CardTypePipe {
    transform(number) {
        if (!number) {
            return CardTypes.NONE;
        }
        let regex = new RegExp(CardPattern.VISA_COBRAND);
        if (number.match(regex) !== null) {
            return CardTypes.VISA_COBRAND;
        }
        regex = new RegExp(CardPattern.VISA);
        if (number.match(regex) !== null && this.luhnCheckCreditCard(number)) {
            return CardTypes.VISA;
        }
        regex = new RegExp(CardPattern.MASTER);
        if (number.match(regex) !== null && this.luhnCheckCreditCard(number)) {
            return CardTypes.MASTER_CARD;
        }
        regex = new RegExp(CardPattern.AMEX);
        if (number.match(regex) !== null && this.luhnCheckCreditCard(number)) {
            return CardTypes.AMEX;
        }
        regex = new RegExp(CardPattern.DISCOVER);
        if (number.match(regex) !== null && this.luhnCheckCreditCard(number)) {
            return CardTypes.DISCOVER;
        }
        regex = new RegExp(CardPattern.DINERS);
        if (number.match(regex) !== null && this.luhnCheckCreditCard(number)) {
            return CardTypes.DINERS;
        }
        regex = new RegExp(CardPattern.JCB);
        if (number.match(regex) !== null && this.luhnCheckCreditCard(number)) {
            return CardTypes.JCB;
        }
        return CardTypes.NONE;
    }
    luhnCheckCreditCard(num) {
        let digit, odd, sum, _i, _len;
        odd = true;
        sum = 0;
        const digits = (num + '').split('').reverse();
        for (_i = 0, _len = digits.length; _i < _len; _i++) {
            digit = digits[_i];
            digit = parseInt(digit, 10);
            if ((odd = !odd)) {
                digit *= 2;
            }
            if (digit > 9) {
                digit -= 9;
            }
            sum += digit;
        }
        return sum % 10 === 0;
    }
}
CardTypePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CardTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CardTypePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CardTypePipe, name: "cardType" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CardTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'cardType',
                }]
        }] });

class CardTypeModule {
}
CardTypeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CardTypeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CardTypeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CardTypeModule, declarations: [CardTypePipe], imports: [CommonModule], exports: [CardTypePipe] });
CardTypeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CardTypeModule, providers: [CardTypePipe], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CardTypeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [CardTypePipe],
                    providers: [CardTypePipe],
                    exports: [CardTypePipe]
                }]
        }] });

export { CardPattern, CardTypeImageUrls, CardTypeModule, CardTypePipe, CardTypes };
